import { render, staticRenderFns } from "./contactBox.vue?vue&type=template&id=21253ce6"
import script from "./contactBox.vue?vue&type=script&lang=js"
export * from "./contactBox.vue?vue&type=script&lang=js"
import style0 from "./contactBox.vue?vue&type=style&index=0&id=21253ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports